import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  loaderLine: {
    width: '100%',
    height: '3px',
    position: 'absolute',
    overflow: 'hidden',
    backgroundColor: '#ddd',
    borderRadius: '20px',
    zIndex: 9999,
    top: '0px',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: '0px',
      left: '-50%',
      height: '3px',
      width: '40%',
      backgroundColor: theme.palette.error.main, // or specify your desired color here
      animation: '$lineAnim 1s linear infinite',
      borderRadius: '20px',
    },
  },
  '@keyframes lineAnim': {
    '0%': {
      left: '-50%',
      width: '40%',
    },
    '100%': {
      left: '100%',
      width: '40%',
    },
  },
}));

function VideoLineLoader(props) {
  const { isLoading } = props;
  const classes = useStyles();

  if (!isLoading) {
    return null;
  }

  return <div className={classes.loaderLine} />;
}

export default VideoLineLoader;
